import React, { ElementType, HTMLAttributes } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import twMerge from 'utilities/src/twMerge';

interface PurifiedTextProps extends HTMLAttributes<HTMLOrSVGElement> {
  children: string;
  as?: ElementType;
  hrefLink?: string;
  allowedTags?: string[];
  addAttr?: string[];
  textRef?: React.RefObject<HTMLElement | null>;
  resetLists?: boolean;
}

export default function PurifiedText({
  as: Tag = 'div',
  children,
  hrefLink,
  className,
  allowedTags = ['strong', 'span', 'br'],
  addAttr,
  textRef,
  resetLists = false,
  ...otherProps
}: PurifiedTextProps) {
  const config = {
    ADD_TAGS: allowedTags,
    ADD_ATTR: addAttr,
  };
  const listReset = resetLists
    ? '[&_ul]:mb-[1em] [&_ul]:mt-[1em] [&_ul]:list-disc [&_ul]:ps-10  [&_ol]:mb-[1em] [&_ol]:mt-[1em] [&_ol]:list-decimal [&_ol]:ps-10'
    : '';

  const defaultClasses = '[&>p:not(:last-child)]:pb-4';

  return (
    <Tag
      className={twMerge(className, defaultClasses, listReset)}
      {...otherProps}
      ref={textRef}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(children, config),
      }}
      href={hrefLink}
    />
  );
}
